import moment from "moment-mini";

import config from "../../config";

export const isPaymentWithinInvoiceGenerationWindow = (
  datetimeUtc,
  now = moment()
) => {
  if (!datetimeUtc) {
    return false;
  }

  const paymentDate = moment(datetimeUtc);

  if (!paymentDate.isValid()) {
    return false;
  }

  const windowStart = moment(now).subtract(
    config.invoiceGenerationWindowDays,
    "days"
  );

  return paymentDate.isSameOrAfter(windowStart);
};
